import { cn } from '@forest/shared'
import { mergeProps } from 'solid-js'
import type { JSX } from 'solid-js'
import '~/styles/gradient-border.css'

type Size = number | string

export type Props = {
  children?: JSX.Element
  className?: string
  style?: JSX.CSSProperties
  borderWidth?: Size
  radius: Size
  gradient?: string
}

export function GradientBorderBox(props: Props) {
  const merged = mergeProps(
    {
      borderWidth: 1.5,
      gradient: 'linear-gradient(90deg, #FFFFFF4D, #FFFFFF1A)',
    },
    props,
  )

  const cssVars = (): JSX.CSSProperties => ({
    ['--border-width' as any]:
      typeof merged.borderWidth === 'number'
        ? `${merged.borderWidth}px`
        : merged.borderWidth,
    ['--radius' as any]:
      typeof merged.radius === 'number' ? `${merged.radius}px` : merged.radius,
    ['--gradient' as any]: merged.gradient,
  })

  return (
    <span
      class={cn('gradient-border relative', merged.className)}
      style={{ ...cssVars(), ...merged.style }}
    >
      {merged.children}
    </span>
  )
}
